// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel--cushion[data-v-c2dfb238]{display:flex;justify-content:space-evenly}", ""]);
// Exports
module.exports = exports;
